<template>
  <div class="w-full">
    <el-form :model="updateForm" :label-position="labelPosition" :rules="rules" ref="updateForm">
      <DeliveryMethodForm :form="updateForm" /><br>
      <el-form-item :gutter="20" class="px-5">
        <el-button type="primary" @click="update('updateForm')" :loading="updating">Update</el-button>
        <el-button @click="cancelUpdate" type="info">Cancel</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>

import DeliveryMethodForm from './_includes/DeliveryMethodForm.vue';

export default {
  name: 'UpdateDeliveryMethod',
  components: {
    DeliveryMethodForm,
  },
  data() {
    return {
      updating: false,
      labelPosition: 'top',
      rules: this.$store.state.InventoryModule.Suppliers.validate_form,
    };
  },
  computed: {
    updateForm() {
      return this.$store.state.SettingsModule.DeliveryMethods.delivery_method;
    },
  },
  async mounted() {
    this.setBreadCrumbs(this.$route.meta.breadCrumbs);
    try {
      await this.$store.dispatch('SettingsModule/DeliveryMethods/getDeliveryMethod', this.$route.params.id);
    } catch (e) {
      this.$notify.error({
        title: 'Error',
        message: 'Something went wrong please try again.',
      });
    }
  },
  methods: {
    async cancelUpdate() {
      this.$router.back();
    },
    update(updateForm) {
      const formData = {
        name: this.updateForm.name,
        shipper_id: this.updateForm.shipper_id,
        delivery_max_miles: this.updateForm.delivery_max_miles,
        delivery_init_miles: this.updateForm.delivery_init_miles,
        delivery_init_mile_cost: this.updateForm.delivery_init_mile_cost,
        delivery_additional_mile_cost: this.updateForm.delivery_additional_mile_cost,
        free_delivery_max_miles: this.updateForm.free_delivery_max_miles,
        free_delivery_min_amount: this.updateForm.free_delivery_min_amount,
        default: this.updateForm.default,
        status: this.updateForm.status,
      };
      this.$refs[updateForm].validate(async (valid) => {
        if (valid) {
          try {
            this.updating = true;
            await this.$store.dispatch('SettingsModule/DeliveryMethods/updateDeliveryMethod', {
              deliveryMethodId: this.$route.params.id, delivery_method: formData,
            });
            await this.$router.push(`/ecommerce/settings/delivery-methods/${this.$route.params.id}/details`);
            this.$notify.success({
              title: 'Success',
              message: 'Delivery method update was successful.',
            });
          } catch (e) {
            this.$notify.error({
              title: 'Error',
              message: 'Something went wrong please try again.',
            });
          }
          this.updating = false;
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style scoped>

</style>
